import {createSvgIcon} from '../create-svg-icon';

export const CallReceivedIcon = createSvgIcon(
  <path d="M20 5.41 18.59 4 7 15.59V9H5v10h10v-2H8.41L20 5.41z" />
, 'CallReceivedOutlined');
